(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/components/game-card/game-card.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/components/game-card/game-card.js');

'use strict';

const Brand = svs.ui.ReactBrand;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const _dateFns = dateFns,
  isToday = _dateFns.isToday,
  parseISO = _dateFns.parseISO;
const getLocalizedWeekday = svs.utils.date.getLocalizedWeekday;
const _svs$numbergames$prod = svs.numbergames.productMapping,
  getBrandingClass = _svs$numbergames$prod.getBrandingClass,
  isEurojackpot = _svs$numbergames$prod.isEurojackpot,
  isLotto = _svs$numbergames$prod.isLotto;
const _svs$numbergames$camp = svs.numbergames.campaign,
  openCampaignApi = _svs$numbergames$camp.openCampaignApi,
  CAMPAIGN_CONSTANTS = _svs$numbergames$camp.CONSTANTS;
const _svs$gamePackage$comp = svs.gamePackage.components,
  ExtraGameInfo = _svs$gamePackage$comp.ExtraGameInfo,
  GameCardBody = _svs$gamePackage$comp.GameCardBody,
  CampaignInfo = _svs$gamePackage$comp.CampaignInfo;
const _svs$ui$ReactCard = svs.ui.ReactCard,
  Card = _svs$ui$ReactCard.Card,
  CardHeader = _svs$ui$ReactCard.CardHeader,
  CardBody = _svs$ui$ReactCard.CardBody,
  CardExpandableBody = _svs$ui$ReactCard.CardExpandableBody;
const RibbonCorner = svs.ui.ReactRibbon.RibbonCorner;
const isSelfService = svs.core.config.data.svsconfig.isSelfService;
const _svs$gamePackage$redu = svs.gamePackage.redux.selectors,
  selectGame = _svs$gamePackage$redu.selectGame,
  selectDraw = _svs$gamePackage$redu.selectDraw,
  selectJackpot = _svs$gamePackage$redu.selectJackpot;
const GameCard = _ref => {
  let uniqueId = _ref.uniqueId,
    _ref$isExpandable = _ref.isExpandable,
    isExpandable = _ref$isExpandable === void 0 ? false : _ref$isExpandable,
    packageIsClosed = _ref.packageIsClosed;
  const game = useSelector(state => selectGame(state, uniqueId));
  const productId = game.productId,
    productItsId = game.productItsId,
    boards = game.boards,
    hasJoker = game.hasJoker,
    hasLotto2 = game.hasLotto2,
    price = game.price;
  const draw = useSelector(state => selectDraw(state, productItsId));
  const _useSelector = useSelector(state => selectJackpot(state, productItsId)),
    jackpotText = _useSelector.jackpotText;
  const hasOpenCampaign = openCampaignApi.hasOpenCampaign(productItsId, {
    draw,
    drawTypeId: CAMPAIGN_CONSTANTS.DRAW_TYPE.CAMPAIGN
  });
  const expandable = isExpandable || isLotto(productId) || hasOpenCampaign;
  return React.createElement("div", {
    className: "gp-game-card"
  }, React.createElement(Card, {
    align: "center",
    expandable: expandable,
    className: packageIsClosed ? 'card-faded' : ''
  }, React.createElement(CardHeader, {
    className: "branding-".concat(getBrandingClass(productId) || 'default')
  }, hasOpenCampaign && React.createElement(RibbonCorner, null, "Kampanj"), React.createElement("div", null, React.createElement(Brand, {
    brand: productId.toLowerCase(),
    emblem: true,
    size: isEurojackpot(productId) ? 100 : 150
  }), React.createElement("p", {
    className: "card-header-jackpot"
  }, jackpotText))), React.createElement(CardExpandableBody, null, expandable && isSelfService && React.createElement(CampaignInfo, {
    uniqueId: uniqueId
  }), expandable && !isSelfService && React.createElement(GameCardBody, {
    game: game
  })), React.createElement(CardBody, null, React.createElement("p", {
    className: "card-body-header"
  }, packageIsClosed || !draw ? 'Stängt för spel' : "".concat(getLocalizedWeekday(draw.regCloseTime, true, !isToday(parseISO(draw.regCloseTime))))), React.createElement("p", {
    className: "card-boards f-content"
  }, boards.length, " rad", boards.length > 1 && 'er'), React.createElement(ExtraGameInfo, {
    price: price,
    productId: productId,
    hasJoker: hasJoker,
    hasLotto2: hasLotto2
  }))));
};
svs.gamePackage.components.GameCard = GameCard;

 })(window);